import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_PATIENTS,
  GET_PATIENTS_SUCCESS,
  GET_SINGLE_PATIENT,
  GET_SINGLE_PATIENT_SUCCESS,
  EDIT_PATIENT,
  ADD_PATIENT,
  DELETE_PATIENT, CHANGE_STATUS_PATIENTS,
} from "./patients.types";
import { httpRequestsOnErrorsActions } from "../http_requests_on_errors";
import { httpRequestsOnLoadActions } from "../http_requests_on_load";
import { httpRequestsOnSuccessActions } from "../http_requests_on_success";
import { patientsService } from "./patients.service";

function* getPatients({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  if (!payload?.noLoad) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
  }
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    const res = yield call(patientsService.getPatientsService, payload?.params);

    yield put({
      type: GET_PATIENTS_SUCCESS,
      payload: res.data,
    });

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* getSinglePatient({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  if (!payload?.noLoad) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
  }
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    const res = yield call(patientsService.getSinglePatientService, payload?.id);

    yield put({
      type: GET_SINGLE_PATIENT_SUCCESS,
      payload: res.data,
    });

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* addPatient({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(patientsService.addPatientService, payload.body);

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* editPatient({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(patientsService.editPatientService, payload?.id, payload?.body);
    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* deletePatient({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(patientsService.deletePatientService, payload?.id);

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
      httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

function* changeStatus({ payload, type }) {
  yield put(httpRequestsOnErrorsActions.removeError(type));
  yield put(httpRequestsOnLoadActions.appendLoading(type));
  yield put(httpRequestsOnSuccessActions.removeSuccess(type));
  try {
    yield call(
        patientsService.changeStatusPatientService,
        payload?.id,
        payload?.body,
    );

    yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
  } catch (err) {
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(
        httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
    );
  } finally {
    yield put(httpRequestsOnLoadActions.removeLoading(type));
  }
}

export const watchPatients = function* watchPatients() {
  yield takeLatest(GET_PATIENTS, getPatients);
  yield takeLatest(GET_SINGLE_PATIENT, getSinglePatient);
  yield takeLatest(ADD_PATIENT, addPatient);
  yield takeLatest(EDIT_PATIENT, editPatient);
  yield takeLatest(DELETE_PATIENT, deletePatient);
  yield takeLatest(CHANGE_STATUS_PATIENTS, changeStatus);
};
